import { render, staticRenderFns } from "./Diagnosticos.vue?vue&type=template&id=4813f4f6"
import script from "./Diagnosticos.vue?vue&type=script&lang=js"
export * from "./Diagnosticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports